/* template */
<template minapp="mpx" xlang="wxml"><div :style="[(customStyle)] | transRpxStyle" class="card-wrap"><div class="card-wrap-gradual" v-if="(showGradual)"></div><div class="card-wrap-content card-wrap-content1" v-if="(showGradual)"><slot/></div><div class="card-wrap-content" v-else><slot/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m20040920"}'>
.card-wrap {
  margin: 10px 12px;
  // box-shadow: 0px 8px 24px 0px rgba(30, 51, 79, 0.08);
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;

  // border: solid 1px #707070;
  &-gradual {
    height: 44px;
    border-radius: 8px 8px 0 0;
    background-image: linear-gradient(0deg, #ffffff 0%, #cbe0ff 100%);
  }

  &-content1 {
    margin-top: -27px;
    padding: 0;
  }
}
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m20040920"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./card-wrap1.mpx.js?isComponent&outputPath=components%2Fcard-wrap120040920%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./card-wrap1.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcard-wrap120040920%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m20040920"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/card-wrap120040920/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
